<template>
  <div>
    <div class="card card-primary">
      <div class="card-header pt-2 pb-2">
        <a
          data-toggle="collapse"
          href="#lineas_negocio"
          aria-expanded="true"
          id="heading-lineas_negocio"
          class="d-block"
        >
          <i class="fa fa-chevron-down pull-right"></i>
          Lineas Negocio
        </a>
      </div>
      <div id="lineas_negocio" class="collapse show">
        <div class="card-body">
          <!-- Mensaje informativo cuando no tiene permiso de edición -->
          <div v-if="!puedeEditar" class="alert alert-info mb-3">
            <i class="fas fa-info-circle"></i>
            <strong>Líneas de negocio asignadas al vehículo</strong> - Solo
            consulta
          </div>

          <div
            class="row"
            v-for="(linea, index) in listasForms.lineas"
            :key="linea.id"
          >
            <div class="form-group">
              <div
                class="
                  custom-control
                  custom-switch
                  custom-switch-off-secundary
                  custom-switch-on-success
                "
              >
                <input
                  type="checkbox"
                  class="custom-control-input"
                  :id="'linea_' + linea.id"
                  @change="actualizarLinea(linea.id, index)"
                  v-model="form.linea[linea.id]"
                  :disabled="!puedeEditar"
                />
                <label
                  class="custom-control-label"
                  :for="'linea_' + linea.id"
                  :class="{ 'text-muted': !puedeEditar }"
                  >{{ linea.nombre }}</label
                >
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
export default {
  name: "VehiculoLinea",
  props: {
    puedeEditar: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      form: {
        linea: {},
      },
      listasForms: {
        lineas: [],
      },
      cargando: false,
    };
  },
  methods: {
    async actualizarLinea(linea, i) {
      // Si no tiene permiso de edición, no permitir cambios
      if (!this.puedeEditar) {
        return;
      }

      // Si no hay ID (está creando), solo actualizar el estado localmente
      if (!this.$parent.form.id) {
        // Solo mantener el estado local, se guardará cuando se cree el vehículo
        // Notificar al padre si hay al menos una línea seleccionada
        this.$nextTick(() => {
          const lineasSeleccionadas = this.getLineasSeleccionadas();
          this.$parent.lineasSeleccionadas = lineasSeleccionadas.length > 0;
        });
        return;
      }

      // Si hay ID (está editando), guardar inmediatamente
      await axios
        .put("/api/admin/vehiculos/assingOrRevokeLinea", {
          vehiculo_id: this.$parent.form.id,
          linea: linea,
          accion: this.form.linea[linea],
        })
        .then((response) => {
          this.$parent.$refs.VehiculoDocumento.getPaquetes();
          this.$parent.$refs.VehiculoDocumento.getVehiculo(
            this.$parent.form.id,
          );
          this.listasForms.lineas[i].estado = this.form.linea[linea];
          this.$parent.getTiposVehiculos();
          this.$swal({
            icon: "success",
            title: response.data.msg,
            toast: true,
            position: "bottom-end",
            showConfirmButton: false,
            timer: 4000,
            timerProgressBar: true,
          });
        });
    },

    // Método para obtener las líneas seleccionadas (usado al crear)
    getLineasSeleccionadas() {
      const lineasSeleccionadas = [];
      for (const lineaId in this.form.linea) {
        if (this.form.linea[lineaId] === true) {
          lineasSeleccionadas.push(parseInt(lineaId));
        }
      }
      return lineasSeleccionadas;
    },
    getLineasVehiculo() {
      // Siempre cargar todas las líneas disponibles
      axios
        .get("/api/admin/lineasNegocios/lista")
        .then((response) => {
          // Cargar todas las líneas disponibles
          this.listasForms.lineas = response.data.map((linea) => ({
            id: linea.id,
            nombre: linea.nombre,
            estado: false,
          }));

          // Inicializar todos como no seleccionados
          this.form.linea = {}; // Limpiar el objeto
          for (let i = 0; i < this.listasForms.lineas.length; i++) {
            const linea = this.listasForms.lineas[i];
            this.$set(this.form.linea, linea.id, false);
          }

          // Si hay ID (editando), cargar las líneas asignadas al vehículo
          if (this.$parent.form.id) {
            axios
              .get(
                "/api/admin/vehiculos/lineas?vehiculo=" + this.$parent.form.id,
              )
              .then((response) => {
                // Marcar como seleccionadas solo las que tienen estado: true
                response.data.forEach((linea) => {
                  if (linea.estado === true) {
                    this.$set(this.form.linea, linea.id, true);
                  } else {
                    this.$set(this.form.linea, linea.id, false);
                  }
                });
              })
              .catch((error) => {
                console.error("Error al cargar líneas asignadas:", error);
              });
          }
        })
        .catch((error) => {
          console.error("Error al cargar todas las líneas:", error);
        });
    },
  },
  watch: {
    // Observar cambios en el ID del vehículo del padre
    "$parent.form.id": {
      handler(newId, oldId) {
        if (newId && newId !== oldId) {
          // Si hay un nuevo ID, recargar las líneas
          this.getLineasVehiculo();
        }
      },
      immediate: false,
    },

    // Observar cambio de tipo de vehículo
    "$parent.form.tipo_vehiculo_id": {
      async handler(tipoVehiculoId) {
        const activar = [16, 57].includes(Number(tipoVehiculoId));

        if (this.form.linea[17] !== activar) {
          this.$set(this.form.linea, 17, activar);

          const index = this.listasForms.lineas.findIndex((l) => l.id === 17);

          if (index !== -1) {
            await this.actualizarLinea(17, index);
          }
        }
      },
      immediate: true,
    },
  },
  mounted() {
    this.getLineasVehiculo();
  },
};
</script>
